import { c as _c } from "react/compiler-runtime";
import { IcoCreditcard16 } from '@onefootprint/icons';
import { useTranslation } from 'react-i18next';
import BaseHoverCard from '../../../base-hover-card';
import type { FinancialDataItem } from '../../types';
import FinancialDataDetails from '../financial-data-details/financial-data-details';
type FinancialDataProps = {
  cards: FinancialDataItem[];
  bankAccounts: FinancialDataItem[];
  hasNonFinancialFields: boolean;
};
const FinancialData = t0 => {
  const $ = _c(13);
  const {
    cards,
    bankAccounts,
    hasNonFinancialFields
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "events.userData"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("security-logs", t1);
  let t2;
  if ($[1] !== hasNonFinancialFields || $[2] !== t) {
    t2 = () => `${t(_temp)}${hasNonFinancialFields ? "," : ""}`;
    $[1] = hasNonFinancialFields;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getTriggerText = t2;
  const t3 = getTriggerText();
  let t4;
  if ($[4] !== t) {
    t4 = t(_temp2);
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== bankAccounts || $[7] !== cards) {
    t5 = <FinancialDataDetails cards={cards} bankAccounts={bankAccounts} />;
    $[6] = bankAccounts;
    $[7] = cards;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = <BaseHoverCard textTrigger={t3} titleIcon={IcoCreditcard16} titleText={t4}>{t5}</BaseHoverCard>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export default FinancialData;
function _temp($) {
  return $.financialData;
}
function _temp2($_0) {
  return $_0.financialData;
}